import React, { useState } from "react";
import IconWithRoundedBorder from "../borderCir/BoderCir";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign,faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { get_all_depends } from "../../features/userSlice";
import { nodataStyle } from "../../constant/constant";

const FundsHistory = () => {
   const {TYPE}=useParams();
   const { isUserLogedIn,Info,reuest_history } = useSelector((state) => state.users);
   const [fundData,setFundData]=useState([]);

    const dispatch=useDispatch();
    React.useEffect(()=>{
      if(isUserLogedIn){
        let data = new FormData();
        data.append('phone_number',Info?.phone_number);
        dispatch(get_all_depends({request_type:'reuest_history',data:data}));
      }
     },[])

     React.useEffect(()=>{
        if( Array.isArray(reuest_history) && reuest_history.length>0){
            if(TYPE==='ALL_FUND_HISTROY'){
                setFundData(reuest_history);
            }else if(TYPE==='ALL_DEPOSIT'){
            const ALL_DEBIT_HISTORY=reuest_history.filter(item => item.action_type==='Deposite');
                setFundData(ALL_DEBIT_HISTORY);
           }else if(TYPE==='APPROVED_DEPOSITE'){
                const APPROVED_HISTORY=reuest_history.filter(item => item.status==='1' && item.action_type==='Deposite'); 
                setFundData(APPROVED_HISTORY);
           }else if(TYPE==='ALL_WITHDRAWAL'){
            const ALL_WITHDRAWAL=reuest_history.filter(item => item.action_type==='Withdraw');
            setFundData(ALL_WITHDRAWAL);
           }else if(TYPE==='APPROVED_WITHDRAWAL'){
            const APPROVED_WITHDRAWAL=reuest_history.filter(item => item.status==='1' && item.action_type==='Withdraw'); 
            setFundData(APPROVED_WITHDRAWAL);
           }
        }
     },[reuest_history]);
    
return (
        <div className="all_bids" style={{padding:'4%'}}>
           {fundData.map((data_camp, index) => ( 
                    <div class="game-card">
                        <div className="upper_fund_card">
                                    <div className="game_card_left" style={{textAlign:'left'}}>
                                        <div className="game-name marginAcc colorRed" >{data_camp.date.split('-').join('/')}</div>   
                                        <div className="game-name marginAcc" style={{fontSize:'small'}} ><span style={{fontWeight:'600'}}> FUND ID</span> :{data_camp.remark}</div>    
                                        <div className="game-name marginAcc colorRed" ><FontAwesomeIcon fontWeight={'300'} icon={faIndianRupeeSign} size='1x'/>{data_camp.points}</div>    
                                    </div>
                                    <div className="game_card_right">
                                       <div className="game-name" style={{whiteSpace:'nowrap'}}>{data_camp.status==="0"?<span style={{color:'#b9b925'}}>In Process</span>:(data_camp.status==="-1")?<span style={{color:'#007bff'}}>Declined</span>:<span style={{color:'green'}}>Success</span>}</div>    
                                    </div>
                           </div>
                           <br/>
                               
                                    <div className="footer_fund">
                                    <div className="footer_fund_first"> 
                                        <IconWithRoundedBorder paddingBox={'9px'} outerColor={'white'} boxColor={'#9e9e9e'} innerColor={'white'} FonCompo={<FontAwesomeIcon icon={faMoneyBill} color="#007bff" size="1x"/>}/>
                                    </div>
                                       <div className="footer_fund_second"> 
                                        <p style={{color:'#9e9e9e'}}>Request Type</p>
                                        <p style={{fontWeight:'500'}}>{data_camp.action_type}</p>
                                        </div>
                                    </div>
                                
                    </div>
        ))}

        {
          (fundData.length===0) && nodataStyle('No Data Histroy Found.')
         }

<br/><br/><br/>
<style jsx>
        {
            `.game-card {
                background-color: #fff;
                padding: 15px;
                margin-bottom: 15px;
                border-radius: 9px;
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
                display: flex;
                flex-direction: column;
            }
             .upper_fund_card{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
             }   
            .colorRed{
            color:#007bff;
            }
            .marginAcc{
            margin-top:6px;
            }
            .footer_fund{
            display: flex;
            flex-direction: row;
            }
            .footer_fund_second{
            margin-left:3%;
            }
          `
        }
</style>
        </div>
        
    );
};

export default FundsHistory;
